// ========================================
// TEXTURES & PATTERNS DATA
// ========================================

export const textureCategories = [
  {
    id: 'water',
    slug: 'water',
    emoji: '🌊',
    name: { en: 'Water', fr: 'Eau' },
    description: {
      en: 'Oceans, pools, rivers, and water drops',
      fr: 'Océans, piscines, rivières et gouttes d’eau'
    },
    difficulty: 'intermediate',
    color: '#A8D8EA'
  },
  {
    id: 'fur',
    slug: 'fur',
    emoji: '🧸',
    name: { en: 'Fur & Fluff', fr: 'Fourrure' },
    description: {
      en: 'Fluffy animals, plushies, cozy textures',
      fr: 'Animaux duveteux, peluches, textures cozy'
    },
    difficulty: 'intermediate',
    color: '#E8D4C4'
  },
  {
    id: 'leopard',
    slug: 'leopard',
    emoji: '🐆',
    name: { en: 'Leopard Spots', fr: 'Taches de léopard' },
    description: {
      en: 'Animal print, spots and rosettes',
      fr: 'Imprimé animal, taches et rosettes'
    },
    difficulty: 'beginner',
    color: '#D4A26A'
  },
  {
    id: 'grass',
    slug: 'grass',
    emoji: '🌿',
    name: { en: 'Grass', fr: 'Herbe' },
    description: {
      en: 'Lawns, meadows, ground cover',
      fr: 'Pelouses, prairies, couvre-sol'
    },
    difficulty: 'beginner',
    color: '#B5C99A'
  },
  {
    id: 'wood',
    slug: 'wood',
    emoji: '🪵',
    name: { en: 'Wood', fr: 'Bois' },
    description: {
      en: 'Floors, tree trunks, furniture',
      fr: 'Planchers, troncs d’arbres, meubles'
    },
    difficulty: 'intermediate',
    color: '#C9A86C'
  },
  {
    id: 'brick',
    slug: 'brick',
    emoji: '🧱',
    name: { en: 'Brick', fr: 'Briques' },
    description: {
      en: 'Walls, fireplaces, exteriors',
      fr: 'Murs, cheminées, extérieurs'
    },
    difficulty: 'beginner',
    color: '#D4A484'
  },
  {
    id: 'rock',
    slug: 'rock',
    emoji: '🪨',
    name: { en: 'Rock', fr: 'Roche' },
    description: {
      en: 'Stones, cliffs, pebbles and boulders',
      fr: 'Pierres, falaises, galets et rochers'
    },
    difficulty: 'intermediate',
    color: '#A8A29E'
  },
  {
    id: 'knit',
    slug: 'knit',
    emoji: '🧶',
    name: { en: 'Knit', fr: 'Tricot' },
    description: {
      en: 'Sweaters, blankets, cozy knits',
      fr: 'Pulls, couvertures, tricots cozy'
    },
    difficulty: 'advanced',
    color: '#E8C4C4'
  },
  {
    id: 'rain',
    slug: 'rain',
    emoji: '🌧️',
    name: { en: 'Rain', fr: 'Pluie' },
    description: {
      en: 'Rain drops, puddles, wet surfaces',
      fr: 'Gouttes de pluie, flaques, surfaces mouillées'
    },
    difficulty: 'beginner',
    color: '#A8C8D8'
  },
  {
    id: 'leaves',
    slug: 'leaves',
    emoji: '🍃',
    name: { en: 'Leaves', fr: 'Feuilles' },
    description: {
      en: 'Trees, bushes, foliage',
      fr: 'Arbres, buissons, feuillage'
    },
    difficulty: 'beginner',
    color: '#8B9B7A'
  },
  {
    id: 'cactus',
    slug: 'cactus',
    emoji: '🌵',
    name: { en: 'Cactus', fr: 'Cactus' },
    description: {
      en: 'Succulents and desert plants',
      fr: 'Plantes grasses et plantes du désert'
    },
    difficulty: 'beginner',
    color: '#8BA86A'
  },
  {
    id: 'flowers',
    slug: 'flowers',
    emoji: '🌸',
    name: { en: 'Flowers', fr: 'Fleurs' },
    description: {
      en: 'Petals, blooms and garden flowers',
      fr: 'Pétales, corolles et fleurs de jardin'
    },
    difficulty: 'beginner',
    color: '#F4B4D0'
  },
  {
    id: 'tiles',
    slug: 'tiles',
    emoji: '🔲',
    name: { en: 'Tiles', fr: 'Carrelage' },
    description: {
      en: '3D floor tiles, geometric patterns',
      fr: 'Carrelage 3D, motifs géométriques'
    },
    difficulty: 'advanced',
    color: '#B8C4CE'
  },
  {
    id: 'fabric',
    slug: 'fabric',
    emoji: '👗',
    name: { en: 'Fabric', fr: 'Tissu' },
    description: {
      en: 'Silk, satin, dresses, curtains',
      fr: 'Soie, satin, robes, rideaux'
    },
    difficulty: 'intermediate',
    color: '#D4A4B4'
  },
  {
    id: 'sky',
    slug: 'sky',
    emoji: '🌅',
    name: { en: 'Sky', fr: 'Ciel' },
    description: {
      en: 'Sunsets, sunrises, clouds',
      fr: 'Couchers de soleil, aurores, nuages'
    },
    difficulty: 'beginner',
    color: '#E8A87C'
  },
  {
    id: 'bubbles',
    slug: 'bubbles',
    emoji: '🫧',
    name: { en: 'Bubbles', fr: 'Bulles' },
    description: {
      en: 'Bath bubbles, soap, magical effects',
      fr: 'Bulles de bain, savon, effets magiques'
    },
    difficulty: 'beginner',
    color: '#C8E8F0'
  },
  {
    id: 'glass-jars',
    slug: 'glass-jars',
    emoji: '🏮',
    name: { en: 'Glass Jar Lanterns', fr: 'Bocaux de lumière' },
    description: {
      en: 'Mason jars and glass lanterns with warm light',
      fr: 'Pots maçons et lanternes en verre transparent, lumière chaude'
    },
    difficulty: 'advanced',
    color: '#E8B96E'
  }
];

const mkSteps = (items) =>
  items.map((item, idx) => ({
    number: idx + 1,
    title: item.title,
    description: item.description,
    tip: item.tip
  }));

const mkTutorial = ({ title, intro, markers, extras, steps, proTips, palette }) => ({
  title,
  intro,
  supplies: { markers, extras },
  steps: mkSteps(steps),
  proTips,
  suggestedPalette: palette
});

export const textureTutorials = {
  water: mkTutorial({
    title: { en: 'Water & Ocean', fr: 'Eau & Océan' },
    intro: {
      en: 'Create movement with curved strokes and preserve white highlights for shine.',
      fr: 'Crée du mouvement avec des lignes courbes et garde des reflets blancs.'
    },
    markers: [
      { code: 'B2', name: 'Light Blue', hex: '#A8D8EA' },
      { code: 'B4', name: 'Medium Blue', hex: '#5DADE2' },
      { code: 'B7', name: 'Deep Blue', hex: '#2E86AB' }
    ],
    extras: [
      { en: 'White gel pen', fr: 'Stylo gel blanc' },
      { en: 'Colorless blender', fr: 'Blender incolore' }
    ],
    steps: [
      {
        title: { en: 'Base Layer', fr: 'Couche de base' },
        description: {
          en: 'Apply the lightest blue in horizontal curved strokes, keep white spots.',
          fr: 'Applique le bleu clair en traits courbes horizontaux et garde des zones blanches.'
        },
        tip: { en: 'Work in small wet sections.', fr: 'Travaille par petites zones humides.' }
      },
      {
        title: { en: 'Add Depth', fr: 'Ajouter de la profondeur' },
        description: {
          en: 'Add medium blue in lower parts and between highlights.',
          fr: 'Ajoute le bleu moyen en bas et entre les reflets.'
        },
        tip: { en: 'Keep lines organic.', fr: 'Garde des lignes organiques.' }
      },
      {
        title: { en: 'Highlights', fr: 'Reflets' },
        description: {
          en: 'After drying, draw white curved highlights with gel pen.',
          fr: 'Une fois sec, ajoute des reflets courbes blancs.'
        },
        tip: { en: 'Broken lines look natural.', fr: 'Des lignes brisées paraissent plus naturelles.' }
      }
    ],
    proTips: [
      { en: 'Pool water uses cleaner parallel lines.', fr: 'L’eau de piscine utilise des lignes plus parallèles.' },
      { en: 'Ocean water needs deeper contrast.', fr: 'L’océan demande plus de contraste.' }
    ],
    palette: {
      ohuhu: ['B2', 'B4', 'B7', 'BG3'],
      copic: ['B23', 'B26', 'B29', 'BG15'],
      prismacolor: ['PC 1023', 'PC 903', 'PC 901', 'PC 905']
    }
  }),

  fur: mkTutorial({
    title: { en: 'Fur & Fluff', fr: 'Fourrure & Duvet' },
    intro: {
      en: 'Short flicking strokes create soft fluffy texture for animals and plushies.',
      fr: 'Des traits courts en tapotement créent une fourrure douce et duveteuse.'
    },
    markers: [
      { code: 'E1', name: 'Light Beige', hex: '#F5DEB3' },
      { code: 'E3', name: 'Medium Tan', hex: '#D4B896' },
      { code: 'E5', name: 'Brown', hex: '#A67B5B' }
    ],
    extras: [
      { en: 'White acrylic marker', fr: 'Marqueur acrylique blanc' },
      { en: 'Fine tip', fr: 'Pointe fine' }
    ],
    steps: [
      {
        title: { en: 'Light Base', fr: 'Base claire' },
        description: {
          en: 'Lay a light base with flicks in fur direction.',
          fr: 'Pose une base claire avec des tapotements dans le sens du poil.'
        },
        tip: { en: 'Lift the marker at stroke end.', fr: 'Lève le marqueur en fin de trait.' }
      },
      {
        title: { en: 'Mid-tones', fr: 'Tons moyens' },
        description: {
          en: 'Add medium flicks in shadow zones and keep gaps.',
          fr: 'Ajoute des traits moyens dans les ombres en gardant des espaces.'
        },
        tip: { en: 'Vary stroke lengths.', fr: 'Varie la longueur des traits.' }
      },
      {
        title: { en: 'Highlight Strands', fr: 'Reflets des mèches' },
        description: {
          en: 'Add a few bright strands with white acrylic marker.',
          fr: 'Ajoute quelques mèches lumineuses au marqueur blanc.'
        },
        tip: { en: 'Use very few highlight lines.', fr: 'Utilise peu de lignes de reflet.' }
      }
    ],
    proTips: [
      { en: 'White fur uses cool grays for shadows.', fr: 'La fourrure blanche utilise des gris froids.' },
      { en: 'Long fur needs longer flicks.', fr: 'La fourrure longue demande des traits plus longs.' }
    ],
    palette: {
      ohuhu: ['E1', 'E3', 'E5', 'WG2'],
      copic: ['E41', 'E44', 'E47', 'W2'],
      prismacolor: ['PC 997', 'PC 946', 'PC 944', 'PC 1074']
    }
  }),

  leopard: mkTutorial({
    title: { en: 'Leopard Spots', fr: 'Taches de léopard' },
    intro: {
      en: 'Create a believable leopard print with irregular rosettes and a touch of shadow. The classic version is tawny; the pink version is more playful — same technique, different base.',
      fr: "Crée un motif léopard crédible avec des rosettes irrégulières et un peu d'ombre. La version classique est fauve, la version rose est plus fun : même technique, base différente."
    },
    markers: [
      { code: 'E21', name: 'Light Tawny',    hex: '#E8C89A' },
      { code: 'E35', name: 'Warm Brown',     hex: '#A9743C' },
      { code: 'E47', name: 'Dark Brown',     hex: '#5C3A1E' }
    ],
    extras: [
      { en: 'Dark wood pencil (outlines)',   fr: 'Crayon de bois foncé (contours)' },
      { en: 'Colorless blender',             fr: 'Blender incolore' }
    ],
    steps: [
      {
        title: {
          en: 'The base',
          fr: 'La base'
        },
        description: {
          en: 'Apply a uniform background colour over the whole area: light tawny for the classic version, soft pink for the pink version.',
          fr: 'Pose une couleur de fond uniforme sur toute la zone : fauve clair pour la version classique, rose tendre pour la version rose.'
        },
        tip: {
          en: 'Keep the base even — it is the canvas for the pattern.',
          fr: "Garde une base bien régulière, c'est la toile du motif."
        }
      },
      {
        title: {
          en: 'The rosettes',
          fr: 'Les rosettes'
        },
        description: {
          en: 'Draw clusters of small irregular shapes, grouped and randomly spaced. These are NOT solid circles: draw open outlines, shaped like a C or a horseshoe.',
          fr: 'Dessine des amas de petites formes irrégulières, groupées et espacées au hasard. Ce ne sont PAS des ronds pleins : trace des contours ouverts, en forme de C ou de fer à cheval.'
        },
        tip: {
          en: 'Irregular and random equals believable. Avoid any alignment.',
          fr: "Irrégulier et aléatoire = crédible. Évite tout alignement."
        }
      },
      {
        title: {
          en: 'The depth',
          fr: 'La profondeur'
        },
        description: {
          en: 'Darken the outline of each rosette with a dark brown, keeping the centre slightly lighter. This gives relief to the pattern.',
          fr: "Assombris le contour des rosettes avec un brun foncé, en gardant le centre un peu plus clair. Ça donne du relief au motif."
        },
        tip: {
          en: 'A centre slightly darker than the base accentuates the rosette effect.',
          fr: "Le centre légèrement plus foncé que la base accentue l'effet rosette."
        }
      }
    ],
    proTips: [
      {
        en: 'Pink version: same technique, but a soft pink base and dark plum/magenta spots.',
        fr: 'Version rose : même technique, mais base rose tendre et taches prune/magenta foncée.'
      },
      {
        en: 'Vary the size of the rosettes and leave empty spaces: a too-regular pattern looks fake.',
        fr: 'Varie la taille des rosettes et laisse des espaces vides : un motif trop régulier paraît faux.'
      }
    ],
    palette: {
      ohuhu:       ['E21', 'E35', 'E47'],
      copic:       ['E21', 'E35', 'E47'],
      prismacolor: ['PC 997', 'PC 946', 'PC 945']
    }
  }),

  grass: mkTutorial({
    title: { en: 'Grass & Lawn', fr: 'Herbe & Pelouse' },
    intro: {
      en: 'Build grass from dark to light using upward flicks in layers.',
      fr: 'Construis l’herbe du foncé au clair avec des traits vers le haut.'
    },
    markers: [
      { code: 'G1', name: 'Light Green', hex: '#C4D8B8' },
      { code: 'G3', name: 'Grass Green', hex: '#7BA05B' },
      { code: 'G5', name: 'Dark Green', hex: '#4A7023' }
    ],
    extras: [
      { en: 'Yellow green marker', fr: 'Marqueur vert jaune' },
      { en: 'White gel pen', fr: 'Stylo gel blanc' }
    ],
    steps: [
      {
        title: { en: 'Dark Base', fr: 'Base foncée' },
        description: {
          en: 'Start with dark green at the bottom with short upward flicks.',
          fr: 'Commence en bas avec le vert foncé et des traits vers le haut.'
        },
        tip: { en: 'Keep random blade heights.', fr: 'Garde des hauteurs de brins variées.' }
      },
      {
        title: { en: 'Medium Layer', fr: 'Couche moyenne' },
        description: {
          en: 'Overlay medium green and blend transitions.',
          fr: 'Superpose le vert moyen et fond les transitions.'
        },
        tip: { en: 'Do not cover all dark strokes.', fr: 'Ne couvre pas tout le foncé.' }
      },
      {
        title: { en: 'Light Tips', fr: 'Pointes claires' },
        description: {
          en: 'Finish with light tips to show sun hit areas.',
          fr: 'Termine avec des pointes claires pour la lumière.'
        },
        tip: { en: 'Add details sparingly.', fr: 'Ajoute les détails avec parcimonie.' }
      }
    ],
    proTips: [
      { en: 'Use yellow browns for fall grass.', fr: 'Utilise des jaunes bruns pour l’automne.' },
      { en: 'Add contact shadows under objects.', fr: 'Ajoute des ombres sous les objets.' }
    ],
    palette: {
      ohuhu: ['G1', 'G3', 'G5', 'YG3'],
      copic: ['G21', 'G28', 'G29', 'YG09'],
      prismacolor: ['PC 920', 'PC 909', 'PC 908', 'PC 989']
    }
  }),

  wood: mkTutorial({
    title: { en: 'Wood Grain', fr: 'Grain du Bois' },
    intro: {
      en: 'Wood texture is about organic flowing grain lines and warm color variation.',
      fr: 'La texture bois repose sur des veines organiques et des tons chauds.'
    },
    markers: [
      { code: 'E2', name: 'Light Wood', hex: '#D4B896' },
      { code: 'E4', name: 'Medium Brown', hex: '#B8956C' },
      { code: 'E6', name: 'Dark Brown', hex: '#8B5A3C' }
    ],
    extras: [
      { en: 'Fine liner', fr: 'Feutre fin' },
      { en: 'White gel pen', fr: 'Stylo gel blanc' }
    ],
    steps: [
      {
        title: { en: 'Base Color', fr: 'Couleur de base' },
        description: {
          en: 'Apply a smooth light base over the whole wood area.',
          fr: 'Applique une base claire uniforme sur toute la zone.'
        },
        tip: { en: 'Follow wood direction.', fr: 'Suis la direction du bois.' }
      },
      {
        title: { en: 'Draw Grain', fr: 'Dessiner le grain' },
        description: {
          en: 'Draw long wavy grain lines with medium brown.',
          fr: 'Dessine de longues veines ondulées avec le brun moyen.'
        },
        tip: { en: 'Keep natural curves and knots.', fr: 'Garde des courbes et nœuds naturels.' }
      },
      {
        title: { en: 'Deepen and Blend', fr: 'Approfondir et estomper' },
        description: {
          en: 'Use dark accents in key veins then soften with the base marker.',
          fr: 'Ajoute des accents foncés puis adoucis avec la base claire.'
        },
        tip: { en: 'Use dark accents sparingly.', fr: 'Utilise peu d’accents foncés.' }
      }
    ],
    proTips: [
      { en: 'Different woods have different grain density.', fr: 'Chaque essence a une densité de grain différente.' },
      { en: 'Weathered wood uses more gray.', fr: 'Le bois vieilli utilise plus de gris.' }
    ],
    palette: {
      ohuhu: ['E2', 'E4', 'E6', 'BR3'],
      copic: ['E41', 'E44', 'E47', 'E29'],
      prismacolor: ['PC 997', 'PC 946', 'PC 944', 'PC 945']
    }
  }),

  brick: mkTutorial({
    title: { en: 'Brick Wall', fr: 'Mur de Briques' },
    intro: {
      en: 'Color each brick with subtle variation and consistent shadow direction.',
      fr: 'Colorie chaque brique avec des variations légères et des ombres cohérentes.'
    },
    markers: [
      { code: 'R3', name: 'Light Red', hex: '#E8A898' },
      { code: 'R5', name: 'Brick Red', hex: '#C67B5C' },
      { code: 'R7', name: 'Dark Red', hex: '#A0522D' }
    ],
    extras: [
      { en: 'Gray marker for grout', fr: 'Marqueur gris pour mortier' },
      { en: 'Fine liner', fr: 'Feutre fin' }
    ],
    steps: [
      {
        title: { en: 'Color Grout', fr: 'Colorier le mortier' },
        description: {
          en: 'Start with grout lines in light to mid gray.',
          fr: 'Commence par les lignes de mortier en gris clair à moyen.'
        },
        tip: { en: 'Grout tone changes the style.', fr: 'La teinte du mortier change le style.' }
      },
      {
        title: { en: 'Brick Base', fr: 'Base des briques' },
        description: {
          en: 'Fill bricks with medium red and vary pressure per brick.',
          fr: 'Remplis les briques en rouge moyen et varie la pression.'
        },
        tip: { en: 'Variation is key.', fr: 'La variation est essentielle.' }
      },
      {
        title: { en: '3D Shadows', fr: 'Ombres 3D' },
        description: {
          en: 'Add darker red on one side to give volume.',
          fr: 'Ajoute du rouge foncé sur un côté pour donner du volume.'
        },
        tip: { en: 'Keep one light direction.', fr: 'Garde une seule direction de lumière.' }
      }
    ],
    proTips: [
      { en: 'Do not outline every brick.', fr: "N'encadre pas chaque brique." },
      { en: 'Use tiny texture dots for old walls.', fr: 'Ajoute des points de texture pour les vieux murs.' }
    ],
    palette: {
      ohuhu: ['R3', 'R5', 'R7', 'CG3'],
      copic: ['E13', 'E17', 'E29', 'C3'],
      prismacolor: ['PC 1032', 'PC 944', 'PC 945', 'PC 1074']
    }
  }),

  rock: mkTutorial({
    title: { en: 'Rock & Stone', fr: 'Roche & Pierre' },
    intro: {
      en: 'Build a raw texture by layering warm grays and browns, then blend everything by going over it several times.',
      fr: 'Construis une texture brute en superposant des gris chauds et des bruns, puis fonds tout en repassant plusieurs fois.'
    },
    markers: [
      { code: 'WG1', name: 'Pale Warm Gray',   hex: '#D6D0C8' },
      { code: 'WG3', name: 'Medium Warm Gray',  hex: '#A8A29E' },
      { code: 'WG5', name: 'Dark Warm Gray',    hex: '#6E665E' },
      { code: 'E21', name: 'Light Brown',        hex: '#C9A86C' },
      { code: 'E47', name: 'Dark Brown',         hex: '#8B6F47' }
    ],
    extras: [
      { en: 'Black wood pencil',           fr: 'Crayon de bois noir' },
      { en: 'White wood pencil',           fr: 'Crayon de bois blanc' },
      { en: 'Gray wood pencils (assorted)', fr: 'Crayons de bois gris (assortiment)' }
    ],
    steps: [
      {
        title: {
          en: 'Identify the light, lay your gray base',
          fr: 'Repère la lumière, pose ta base grise'
        },
        description: {
          en: 'Decide where the light comes from (for example, from the top, slightly to the right). Start with your palest gray on top of the rock, in random sections. Layer a second close gray on top and go over it several times to blend.',
          fr: "Décide d'où vient la lumière (par exemple en haut, légèrement à droite). Commence par ton gris le plus pâle sur le dessus de la roche, en sections aléatoires. Superpose un deuxième gris proche et repasse plusieurs fois pour fondre."
        },
        tip: {
          en: 'Light guides everything: keep the top lighter.',
          fr: 'La lumière guide tout : garde le dessus plus clair.'
        }
      },
      {
        title: {
          en: 'Add texture with the brown',
          fr: 'Ajoute de la texture avec le brun'
        },
        description: {
          en: 'With your light brown, make small scattered circles to give grain to the rock. With the dark brown, place small shadow touches just below each brown spot.',
          fr: "Avec ton brun pâle, fais des petits cercles éparpillés pour donner du grain à la roche. Avec le brun foncé, dépose de petites touches d'ombre juste sous chaque tache brune."
        },
        tip: {
          en: 'It looks subtle at first, but the texture shows up as it dries.',
          fr: 'Ça paraît discret au début, mais la texture ressort au séchage.'
        }
      },
      {
        title: {
          en: 'Create depth and blend everything',
          fr: 'Crée la profondeur et fonds tout'
        },
        description: {
          en: 'Layer darker grays section by section, and always come back with a pale gray on top to erase the boundaries. Finish by marking the shadow line at the bottom with your darkest gray, then blend it again.',
          fr: "Superpose des gris plus foncés section par section, et reviens toujours avec un gris pâle par-dessus pour effacer les démarcations. Termine en marquant la ligne d'ombre du bas avec ton gris le plus foncé, puis refonds-la."
        },
        tip: {
          en: 'The secret: go over it multiple times to blend colors and make transitions disappear.',
          fr: 'Le secret : repasser plusieurs fois pour mélanger les couleurs et faire disparaître les jonctions.'
        }
      },
      {
        title: {
          en: 'Cracks and finishing touches with wood pencils',
          fr: 'Fissures et finitions aux crayons de bois'
        },
        description: {
          en: 'Draw cracks with a black pencil (irregular and random lines), then add a small white stroke just above each one for a highlight. Camouflage the black with your gray pencils (from light to dark), and deepen the final shadow with the black pencil at the bottom of the rock and under the cracks.',
          fr: "Trace des fissures au crayon noir (lignes irrégulières et aléatoires), puis ajoute un petit trait blanc juste au-dessus de chacune pour un point de lumière. Camoufle le noir avec tes crayons gris (du pâle vers le foncé), et accentue l'ombre finale au crayon noir dans le bas de la roche et sous les fissures."
        },
        tip: {
          en: 'The wood pencil also fixes small colour bleeds.',
          fr: 'Le crayon de bois rattrape aussi les petits débordements.'
        }
      }
    ],
    proTips: [
      {
        en: 'The real secret of rocks: go over your colours multiple times to blend them, until no boundary shows.',
        fr: "Le vrai secret des roches : repasser plusieurs fois sur tes couleurs pour les fondre, jusqu'à ce qu'aucune démarcation ne paraisse."
      },
      {
        en: 'Keep your cracks very irregular and random: that is what makes the rock believable.',
        fr: "Garde tes fissures bien irrégulières et aléatoires : c'est ce qui rend la roche crédible."
      }
    ],
    palette: {
      ohuhu:      ['WG1', 'WG3', 'WG5', 'E21', 'E47'],
      copic:      ['W1',  'W3',  'W5',  'E21', 'E47'],
      prismacolor: ['PC 1072', 'PC 1074', 'PC 1076', 'PC 997', 'PC 945']
    }
  }),

  knit: mkTutorial({
    title: { en: 'Knit Texture', fr: 'Texture Tricot' },
    intro: {
      en: 'Use repeated V shapes row by row to simulate knitted stitches.',
      fr: 'Utilise des V répétés rangée par rangée pour simuler les mailles.'
    },
    markers: [
      { code: 'RV2', name: 'Light Pink', hex: '#F4C4C4' },
      { code: 'RV4', name: 'Medium Pink', hex: '#E8A4A4' },
      { code: 'RV6', name: 'Deep Pink', hex: '#D478A7' }
    ],
    extras: [
      { en: 'Chisel tips', fr: 'Pointes biseautées' },
      { en: 'White gel pen', fr: 'Stylo gel blanc' }
    ],
    steps: [
      {
        title: { en: 'Plan Rows', fr: 'Planifier les rangées' },
        description: {
          en: 'Split the area into horizontal rows for stitch placement.',
          fr: 'Découpe la zone en rangées horizontales pour placer les mailles.'
        },
        tip: { en: 'Start from center.', fr: 'Commence par le centre.' }
      },
      {
        title: { en: 'Build V Stitches', fr: 'Construire les mailles V' },
        description: {
          en: 'Create small V marks and offset each new row.',
          fr: 'Crée de petits V et décale chaque nouvelle rangée.'
        },
        tip: { en: 'Dry slightly between rows.', fr: 'Laisse sécher légèrement entre les rangées.' }
      },
      {
        title: { en: 'Shadow and Highlight', fr: 'Ombres et reflets' },
        description: {
          en: 'Darken valleys and highlight ridge tops.',
          fr: 'Assombris les creux et éclaircis les crêtes.'
        },
        tip: { en: 'Contrast gives knit depth.', fr: 'Le contraste donne la profondeur.' }
      }
    ],
    proTips: [
      { en: 'Chunky knit uses larger V shapes.', fr: 'Le tricot épais utilise des V plus grands.' },
      { en: 'Cable knit needs extra shadow planning.', fr: 'Les torsades demandent plus de planification.' }
    ],
    palette: {
      ohuhu: ['RV2', 'RV4', 'RV6', 'CG1'],
      copic: ['RV21', 'RV23', 'RV25', 'C1'],
      prismacolor: ['PC 929', 'PC 928', 'PC 930', 'PC 1074']
    }
  }),

  rain: mkTutorial({
    title: { en: 'Rain & Drops', fr: 'Pluie & Gouttes' },
    intro: {
      en: 'Show rain with fine streaks, drops with highlights, and wet surface reflections.',
      fr: 'Dessine la pluie avec de fines traînées, des gouttes avec reflets et des surfaces mouillées.'
    },
    markers: [
      { code: 'BG1', name: 'Light Blue', hex: '#C8D8E4' },
      { code: 'BG3', name: 'Medium Blue', hex: '#A8C8D8' },
      { code: 'CG2', name: 'Cool Gray', hex: '#B8C0C8' }
    ],
    extras: [
      { en: 'White gel pen', fr: 'Stylo gel blanc' },
      { en: 'Fine liner', fr: 'Feutre fin' }
    ],
    steps: [
      {
        title: { en: 'Rain Streaks', fr: 'Traînées de pluie' },
        description: {
          en: 'Draw thin diagonal streaks with a light blue marker.',
          fr: 'Dessine de fines traînées diagonales avec un marqueur bleu clair.'
        },
        tip: { en: 'Keep streaks light and sparse.', fr: 'Garde les traînées légères et espacées.' }
      },
      {
        title: { en: 'Drops', fr: 'Gouttes' },
        description: {
          en: 'Add small tear-shaped drops with a medium blue and white highlights on top.',
          fr: 'Ajoute de petites gouttes en forme de larme avec du bleu moyen et des reflets blancs en haut.'
        },
        tip: { en: 'Highlights make drops look 3D.', fr: 'Les reflets donnent un effet 3D aux gouttes.' }
      },
      {
        title: { en: 'Wet Surfaces', fr: 'Surfaces mouillées' },
        description: {
          en: 'Add subtle reflections on the ground with light gray and blue tones.',
          fr: 'Ajoute des reflets subtils au sol avec des tons gris et bleus clairs.'
        },
        tip: { en: 'Reflections should be softer than the original objects.', fr: 'Les reflets doivent être plus doux que les objets originaux.' }
      }
    ],
    proTips: [
      { en: 'Heavy rain uses denser streaks and darker tones.', fr: 'La pluie forte utilise des traînées plus denses et des tons plus foncés.' },
      { en: 'Puddles are mirror versions of objects above them.', fr: 'Les flaques sont des miroirs des objets au-dessus.' }
    ],
    palette: {
      ohuhu: ['BG1', 'BG3', 'CG2', 'B1'],
      copic: ['B21', 'B23', 'C1', 'C3'],
      prismacolor: ['PC 1023', 'PC 1024', 'PC 1074', 'PC 1072']
    }
  }),

  leaves: mkTutorial({
    title: { en: 'Leaves & Foliage', fr: 'Feuilles & Feuillage' },
    intro: {
      en: 'Layer greens with vein direction to build lively natural foliage.',
      fr: 'Superpose les verts dans le sens des nervures pour un feuillage naturel.'
    },
    markers: [
      { code: 'YG2', name: 'Yellow Green', hex: '#C4D8A8' },
      { code: 'G3', name: 'Leaf Green', hex: '#7BA05B' },
      { code: 'G6', name: 'Dark Green', hex: '#3D5C3D' }
    ],
    extras: [
      { en: 'Yellow marker', fr: 'Marqueur jaune' },
      { en: 'Fine liner optional', fr: 'Feutre fin optionnel' }
    ],
    steps: [
      {
        title: { en: 'Light Base', fr: 'Base claire' },
        description: {
          en: 'Lay a light green base following the leaf direction.',
          fr: 'Pose une base vert clair dans le sens de la feuille.'
        },
        tip: { en: 'Leave central vein lighter.', fr: 'Garde la nervure centrale plus claire.' }
      },
      {
        title: { en: 'Mid and Dark', fr: 'Moyen et foncé' },
        description: {
          en: 'Build depth on edges and overlap areas with medium and dark greens.',
          fr: 'Crée la profondeur sur les bords et chevauchements avec vert moyen et foncé.'
        },
        tip: { en: 'Overlap creates natural shadow.', fr: 'Le chevauchement crée des ombres naturelles.' }
      },
      {
        title: { en: 'Warm Highlights', fr: 'Reflets chauds' },
        description: {
          en: 'Touch yellow-green on sun hit spots and define major veins.',
          fr: 'Ajoute du vert jaune sur les zones ensoleillées et définis les nervures principales.'
        },
        tip: { en: 'Reduce detail for distant leaves.', fr: 'Mets moins de détail pour les feuilles lointaines.' }
      }
    ],
    proTips: [
      { en: 'Fall leaves use warm oranges and reds.', fr: 'En automne, utilise oranges et rouges.' },
      { en: 'Bushes are clusters with green variation.', fr: 'Les buissons sont des groupes avec variation de verts.' }
    ],
    palette: {
      ohuhu: ['YG2', 'G3', 'G6', 'Y3'],
      copic: ['YG03', 'G28', 'G29', 'Y15'],
      prismacolor: ['PC 989', 'PC 909', 'PC 908', 'PC 916']
    }
  }),

  cactus: mkTutorial({
    title: { en: 'Cactus', fr: 'Cactus' },
    intro: {
      en: 'Give your cactus volume with a green gradient, then add bright spines. A simple and satisfying plant to colour.',
      fr: 'Donne du volume à ton cactus avec un dégradé vert, puis des épines lumineuses. Une plante simple et satisfaisante à colorier.'
    },
    markers: [
      { code: 'G1',  name: 'Light Green',  hex: '#B5C99A' },
      { code: 'G3',  name: 'Medium Green', hex: '#8BA86A' },
      { code: 'G5',  name: 'Dark Green',   hex: '#5C7348' },
      { code: 'W0',  name: 'White',        hex: '#FFFFFF' }
    ],
    extras: [
      { en: 'Colorless blender',          fr: 'Blender incolore' },
      { en: 'White marker or white pen',  fr: 'Marqueur/stylo blanc' }
    ],
    steps: [
      {
        title: {
          en: 'The green base',
          fr: 'La base verte'
        },
        description: {
          en: 'Apply light green over the entire cactus, evenly.',
          fr: 'Pose un vert clair sur tout le cactus, de façon uniforme.'
        },
        tip: {
          en: 'This is the starting colour — keep it light.',
          fr: "C'est la couleur de départ, garde-la légère."
        }
      },
      {
        title: {
          en: 'The volume',
          fr: 'Le volume'
        },
        description: {
          en: 'Add medium then dark green on one side and in the vertical grooves, keeping the other side lighter (the light side). The cactus is cylindrical: follow its curve.',
          fr: "Ajoute du vert moyen puis foncé sur un côté et dans les sillons verticaux, en gardant l'autre côté plus clair (le côté lumière). Le cactus est cylindrique : suis sa courbe."
        },
        tip: {
          en: 'Shadows follow a vertical curve, not straight lines.',
          fr: 'Les ombres suivent une courbe verticale, pas des lignes droites.'
        }
      },
      {
        title: {
          en: 'Spines and highlights',
          fr: 'Les épines et reflets'
        },
        description: {
          en: 'With the blender, make small dots along the ridges to mark the spines, then add white on top (small dots and short strokes) to make them stand out. Finish with a highlight on the lit edge.',
          fr: 'Avec le blender, fais de petits points le long des arêtes pour marquer les épines, puis ajoute du blanc par-dessus (petits points et petits traits) pour les faire ressortir. Termine par un reflet sur le bord éclairé.'
        },
        tip: {
          en: 'Fine spines in small groups along the ridges.',
          fr: 'Épines fines et par petits groupes le long des arêtes.'
        }
      }
    ],
    proTips: [
      {
        en: 'A small pink or yellow flower on top adds charm (optional).',
        fr: 'Une petite fleur rose ou jaune en haut ajoute du charme (optionnel).'
      },
      {
        en: 'The light/dark contrast on one side alone is enough to make the volume convincing.',
        fr: "Le contraste clair/foncé d'un seul côté suffit à rendre le volume crédible."
      }
    ],
    palette: {
      ohuhu:       ['G1', 'G3', 'G5', 'YG3'],
      copic:       ['G21', 'G24', 'G28', 'YG09'],
      prismacolor: ['PC 920', 'PC 909', 'PC 908', 'PC 989']
    }
  }),

  flowers: mkTutorial({
    title: { en: 'Flowers', fr: 'Fleurs' },
    intro: {
      en: 'Flowers come to life with a soft gradient from the heart outward to the petal tips, and a hint of shadow for relief.',
      fr: "Les fleurs prennent vie avec un dégradé doux du cœur vers les pointes des pétales et un soupçon d'ombre pour le relief."
    },
    markers: [
      { code: 'RV00', name: 'Pale Rose',   hex: '#FCDEE9' },
      { code: 'RV02', name: 'Medium Rose', hex: '#F4B4D0' },
      { code: 'RV06', name: 'Deep Rose',   hex: '#D88AA8' },
      { code: 'Y21',  name: 'Soft Yellow', hex: '#F4D88A' }
    ],
    extras: [
      { en: 'White gel pen',      fr: 'Stylo gel blanc' },
      { en: 'Colorless blender', fr: 'Blender incolore' }
    ],
    steps: [
      {
        title: {
          en: 'The light base',
          fr: 'La base claire'
        },
        description: {
          en: 'Apply the palest pink evenly across all the petals. Keep it light — this is your canvas.',
          fr: "Applique le rose le plus pâle sur tous les pétales, de façon uniforme. Garde-le bien léger, c'est ta toile."
        },
        tip: {
          en: 'Do not overload — you will come back over it.',
          fr: 'Ne charge pas, tu reviendras dessus.'
        }
      },
      {
        title: {
          en: 'The gradient from heart outward',
          fr: "Le dégradé du cœur vers l'extérieur"
        },
        description: {
          en: 'With the medium pink, start from the centre of the flower (the heart) and work down to the middle of the petals. Keep the tips lighter. Go over it several times to blend well.',
          fr: "Avec le rose moyen, pars du centre de la fleur (le cœur) et descends jusqu'au milieu des pétales. Garde les pointes plus claires. Repasse plusieurs fois pour bien fondre."
        },
        tip: {
          en: 'This gradient is what gives the living quality. The more gradual it is, the more convincing it looks.',
          fr: "C'est ce dégradé qui donne le côté vivant. Plus c'est progressif, plus c'est crédible."
        }
      },
      {
        title: {
          en: 'The shadows for relief',
          fr: 'Les ombres pour le relief'
        },
        description: {
          en: 'With the darker pink, subtly accentuate the areas where petals overlap (at their base and near the heart). A little goes a long way.',
          fr: 'Avec le rose plus foncé, accentue subtilement les zones où les pétales se chevauchent (à leur base et près du cœur). Un peu suffit.'
        },
        tip: {
          en: 'Vary the intensity slightly from one petal to another — otherwise it looks too regular.',
          fr: "Varie légèrement l'intensité d'un pétale à l'autre, sinon ça paraît trop régulier."
        }
      },
      {
        title: {
          en: 'The heart and highlights',
          fr: 'Le cœur et les reflets'
        },
        description: {
          en: 'Add a touch of yellow or orange at the centre to evoke pollen. A few small white highlights on the petal edges with a white gel pen for the light.',
          fr: 'Une touche jaune ou orange au centre pour évoquer le pollen. Quelques petits reflets blancs sur les bords des pétales au stylo blanc pour la lumière.'
        },
        tip: {
          en: 'A luminous heart is what makes the flower irresistible.',
          fr: "Un cœur lumineux, c'est ce qui donne envie de regarder la fleur."
        }
      }
    ],
    proTips: [
      {
        en: 'The secret of successful flowers: a subtle gradient from the heart outward, never the other way around.',
        fr: "Le secret des fleurs réussies : le dégradé subtil du cœur vers les pointes, jamais l'inverse."
      },
      {
        en: 'For bouquets, vary the hue (pink, peach, lavender) from one flower to the next — it gives rhythm.',
        fr: "Pour des bouquets, varie la teinte (rose, pêche, lavande) d'une fleur à l'autre — ça donne du rythme."
      }
    ],
    palette: {
      ohuhu:       ['RV00', 'RV02', 'RV06', 'Y21'],
      copic:       ['RV00', 'RV02', 'RV06', 'Y21'],
      prismacolor: ['PC 929', 'PC 928', 'PC 930', 'PC 916']
    }
  }),

  tiles: mkTutorial({
    title: { en: '3D Tiles', fr: 'Carrelage 3D' },
    intro: {
      en: 'Use consistent light direction to create believable 3D tile relief.',
      fr: 'Utilise une lumière cohérente pour créer un relief de carrelage 3D.'
    },
    markers: [
      { code: 'BG1', name: 'Light Tile', hex: '#E8E8F0' },
      { code: 'CG3', name: 'Medium Gray', hex: '#B8B8C0' },
      { code: 'CG5', name: 'Dark Gray', hex: '#808088' }
    ],
    extras: [
      { en: 'Ruler', fr: 'Règle' },
      { en: 'White gel pen', fr: 'Stylo gel blanc' }
    ],
    steps: [
      {
        title: { en: 'Base Color', fr: 'Couleur de base' },
        description: {
          en: 'Fill all tiles with a light tone and let dry.',
          fr: 'Remplis tous les carreaux avec une teinte claire et laisse sécher.'
        },
        tip: { en: 'Dry layers avoid muddy color.', fr: 'Le séchage évite les mélanges sales.' }
      },
      {
        title: { en: 'Set Shadows', fr: 'Placer les ombres' },
        description: {
          en: 'Apply medium gray on sides opposite to the light source.',
          fr: 'Applique le gris moyen sur les faces opposées à la lumière.'
        },
        tip: { en: 'Use one fixed light direction.', fr: 'Garde une direction de lumière fixe.' }
      },
      {
        title: { en: 'Deep Corners', fr: 'Coins profonds' },
        description: {
          en: 'Add darkest gray in corner intersections and white edge highlights.',
          fr: 'Ajoute le gris foncé dans les coins et des reflets blancs sur les bords.'
        },
        tip: { en: 'Small accents are enough.', fr: 'De petits accents suffisent.' }
      }
    ],
    proTips: [
      { en: 'Hex tiles follow the same logic.', fr: 'Les carreaux hexagonaux suivent la même logique.' },
      { en: 'Color first, then add gray shadows.', fr: 'Pose la couleur puis les ombres grises.' }
    ],
    palette: {
      ohuhu: ['BG1', 'CG3', 'CG5', 'CG7'],
      copic: ['C1', 'C3', 'C5', 'C7'],
      prismacolor: ['PC 1072', 'PC 1074', 'PC 1076', 'PC 935']
    }
  }),

  fabric: mkTutorial({
    title: { en: 'Fabric & Silk', fr: 'Tissu & Soie' },
    intro: {
      en: 'Fabric folds rely on light-dark rhythm and clean highlight peaks.',
      fr: 'Les plis du tissu reposent sur un rythme clair-foncé et des sommets lumineux.'
    },
    markers: [
      { code: 'RV1', name: 'Light Rose', hex: '#F8E4E8' },
      { code: 'RV3', name: 'Medium Rose', hex: '#E4B8C4' },
      { code: 'RV5', name: 'Deep Rose', hex: '#C87898' }
    ],
    extras: [
      { en: 'White gel pen', fr: 'Stylo gel blanc' },
      { en: 'Colorless blender', fr: 'Blender incolore' }
    ],
    steps: [
      {
        title: { en: 'Base Layer', fr: 'Base claire' },
        description: {
          en: 'Lay the light tone and preserve bright highlight bands.',
          fr: 'Pose la teinte claire et préserve des bandes de reflet.'
        },
        tip: { en: 'Silk keeps stronger highlights.', fr: 'La soie garde des reflets plus forts.' }
      },
      {
        title: { en: 'Map Folds', fr: 'Cartographier les plis' },
        description: {
          en: 'Add medium tone in fold valleys and transition areas.',
          fr: 'Ajoute la teinte moyenne dans les creux et transitions de plis.'
        },
        tip: { en: 'Follow fabric tension lines.', fr: 'Suis les lignes de tension du tissu.' }
      },
      {
        title: { en: 'Deep Shadows', fr: 'Ombres profondes' },
        description: {
          en: 'Use dark accents in overlap zones and crease cores.',
          fr: 'Utilise des accents foncés dans les chevauchements et plis profonds.'
        },
        tip: { en: 'Finish with crisp top highlights.', fr: 'Termine avec des reflets nets sur les sommets.' }
      }
    ],
    proTips: [
      { en: 'Satin has sharper contrast than cotton.', fr: 'Le satin a plus de contraste que le coton.' },
      { en: 'Denim can use tiny diagonal texture lines.', fr: 'Le denim peut utiliser de petites lignes diagonales.' }
    ],
    palette: {
      ohuhu: ['RV1', 'RV3', 'RV5', 'V4'],
      copic: ['RV11', 'RV14', 'RV17', 'V15'],
      prismacolor: ['PC 929', 'PC 928', 'PC 930', 'PC 932']
    }
  }),

  sky: mkTutorial({
    title: { en: 'Sunset & Sky', fr: 'Coucher de soleil & Ciel' },
    intro: {
      en: 'Build smooth gradients from horizon light to deep upper sky tones.',
      fr: 'Crée des dégradés doux de l’horizon lumineux vers le haut du ciel.'
    },
    markers: [
      { code: 'Y2', name: 'Pale Yellow', hex: '#FFF8E0' },
      { code: 'YR3', name: 'Peach', hex: '#FFD4A8' },
      { code: 'R4', name: 'Coral', hex: '#FF8C7C' }
    ],
    extras: [
      { en: 'Blue marker for upper sky', fr: 'Marqueur bleu pour le haut du ciel' },
      { en: 'Purple for dramatic sunsets', fr: 'Violet pour couchers dramatiques' }
    ],
    steps: [
      {
        title: { en: 'Horizon Light', fr: 'Lumière à l’horizon' },
        description: {
          en: 'Start with pale yellow at the horizon in horizontal strokes.',
          fr: 'Commence avec un jaune pâle à l’horizon en traits horizontaux.'
        },
        tip: { en: 'Keep some white glow.', fr: 'Garde une lueur blanche.' }
      },
      {
        title: { en: 'Warm Gradient', fr: 'Dégradé chaud' },
        description: {
          en: 'Blend peach and coral upward while still wet.',
          fr: "Fonds pêche et corail vers le haut tant que c'est humide."
        },
        tip: { en: 'Work quickly for smooth blends.', fr: 'Travaille vite pour des fondus doux.' }
      },
      {
        title: { en: 'Upper Sky', fr: 'Haut du ciel' },
        description: {
          en: 'Finish with cool blue or purple at the top and soften transitions.',
          fr: 'Termine avec du bleu ou violet en haut et adoucis les transitions.'
        },
        tip: { en: 'Add silhouettes last.', fr: 'Ajoute les silhouettes en dernier.' }
      }
    ],
    proTips: [
      { en: 'Sunrise uses softer pastel versions.', fr: 'Le lever de soleil utilise des tons pastel plus doux.' },
      { en: 'Cloud undersides catch warm light.', fr: 'Le dessous des nuages capte la lumière chaude.' }
    ],
    palette: {
      ohuhu: ['Y2', 'YR3', 'R4', 'RV5', 'B3'],
      copic: ['Y11', 'YR02', 'R22', 'RV14', 'B23'],
      prismacolor: ['PC 916', 'PC 1033', 'PC 1032', 'PC 929', 'PC 903']
    }
  }),

  bubbles: mkTutorial({
    title: { en: 'Bubbles', fr: 'Bulles' },
    intro: {
      en: 'Keep bubbles transparent with subtle tint and strong white highlights.',
      fr: 'Garde les bulles transparentes avec teintes légères et reflets blancs nets.'
    },
    markers: [
      { code: 'BG0', name: 'Pale Blue', hex: '#E8F4F8' },
      { code: 'BG2', name: 'Light Blue', hex: '#C8E8F0' },
      { code: 'V1', name: 'Pale Violet', hex: '#E8E4F0' }
    ],
    extras: [
      { en: 'White gel pen', fr: 'Stylo gel blanc' },
      { en: 'Colorless blender', fr: 'Blender incolore' }
    ],
    steps: [
      {
        title: { en: 'Light Outline', fr: 'Contour clair' },
        description: {
          en: 'Draw a pale circle outline and keep the center open.',
          fr: 'Dessine un contour circulaire clair et garde le centre ouvert.'
        },
        tip: { en: 'Bubbles are mostly transparent.', fr: 'Les bulles sont surtout transparentes.' }
      },
      {
        title: { en: 'Color Accents', fr: 'Accents couleurs' },
        description: {
          en: 'Add light blue and violet accents on the lower curve.',
          fr: 'Ajoute des accents bleus et violets sur la courbe basse.'
        },
        tip: { en: 'Keep accents very subtle.', fr: 'Garde des accents très subtils.' }
      },
      {
        title: { en: 'White Highlights', fr: 'Reflets blancs' },
        description: {
          en: 'Place 2 to 3 white highlight marks in the upper area.',
          fr: 'Place 2 ou 3 marques de reflet blanc en haut de la bulle.'
        },
        tip: { en: 'One large and one small works well.', fr: 'Un grand et un petit reflet fonctionnent bien.' }
      }
    ],
    proTips: [
      { en: 'Vary size in bubble clusters.', fr: 'Varie les tailles dans les groupes de bulles.' },
      { en: 'Add tiny pink or green for iridescence.', fr: 'Ajoute un peu de rose ou vert pour l’iridescence.' }
    ],
    palette: {
      ohuhu: ['BG0', 'BG2', 'V1', 'RV1'],
      copic: ['B000', 'B21', 'V12', 'RV11'],
      prismacolor: ['PC 1023', 'PC 1024', 'PC 956', 'PC 929']
    }
  }),

  'glass-jars': mkTutorial({
    title: { en: 'Glass Jar Lanterns', fr: 'Bocaux de lumière' },
    intro: {
      en: "A glass jar is a bit like a ghost: you keep seeing the scene behind it, but softer. The warm bulb light contrasts with a bluish halo on the glass.",
      fr: "Un bocal en verre, c'est un peu comme un fantôme : on continue à voir le décor derrière, mais en plus doux. La lumière chaude de l'ampoule contraste avec un halo bleuté sur le verre."
    },
    markers: [
      { code: 'E21',  name: 'Warm Brown',     hex: '#C9A86C' },
      { code: 'Y21',  name: 'Warm Yellow',    hex: '#F5D88A' },
      { code: 'YR03', name: 'Soft Orange',    hex: '#F4C39A' },
      { code: 'BG3',  name: 'Pale Blue',      hex: '#A8C8D8' },
      { code: 'WG1',  name: 'Pale Warm Gray', hex: '#D6D0C8' }
    ],
    extras: [
      { en: 'Colorless blender', fr: 'Blender incolore' },
      { en: 'White gel pen',     fr: 'Stylo gel blanc' }
    ],
    steps: [
      {
        title: {
          en: 'Colour the scene around the jars',
          fr: 'Colorie le décor autour des bocaux'
        },
        description: {
          en: "Start by colouring everything around the jars as you usually would: cushions, wooden table, background. Treat the jars as if they were not there yet.",
          fr: "Commence par colorier tout ce qui se trouve autour des bocaux comme d'habitude : coussins, table en bois, arrière-plan. Fais comme si les bocaux n'étaient pas encore là."
        },
        tip: {
          en: 'A solid scene around the jars makes the transparency effect believable.',
          fr: "Un décor solide autour des bocaux rend l'effet de transparence crédible."
        }
      },
      {
        title: {
          en: 'Continue the scene INSIDE the jars',
          fr: "Poursuis le décor à l'intérieur des bocaux"
        },
        description: {
          en: "The glass is transparent: pick up the same patterns that pass behind each jar and continue them inside the jar shape. Same colours as outside, but version slightly paler.",
          fr: "Le verre est transparent : reprends les mêmes motifs qui passent derrière chaque bocal et poursuis-les à l'intérieur de la forme du bocal. Mêmes couleurs qu'à l'extérieur, mais version un peu plus pâle."
        },
        tip: {
          en: 'Like a ghost effect: the scene shows through, just softer.',
          fr: "Comme un effet fantôme : le décor transparaît, juste en plus doux."
        }
      },
      {
        title: {
          en: 'Diffuse with the blender',
          fr: 'Diffuse avec le blender'
        },
        description: {
          en: "Pass the colourless blender over the inside of the jars to soften the colours and create that 'seen through glass' effect. Keep a brighter zone around the bulb — it is lit from the inside.",
          fr: "Passe le blender incolore sur l'intérieur des bocaux pour adoucir les couleurs et créer cet effet 'vu à travers le verre'. Garde une zone plus claire autour de l'ampoule, elle est éclairée de l'intérieur."
        },
        tip: {
          en: 'If the background colour is too strong, blend it BEFORE drawing the jar.',
          fr: "Si la couleur de fond est trop forte, diffuse-la AVANT de tracer le bocal."
        }
      },
      {
        title: {
          en: 'The warm bulb',
          fr: "L'ampoule chaude"
        },
        description: {
          en: "Colour each bulb with a light warm yellow, then add a touch of soft orange-beige to give that cosy lit feel. The bulb is the warmest, brightest point of the drawing.",
          fr: "Colorie chaque ampoule en jaune chaud léger, puis ajoute une touche d'orange beige doux pour donner ce côté chaleureux et allumé. L'ampoule est le point le plus chaud et le plus lumineux du dessin."
        },
        tip: {
          en: 'Warm + soft orange = cosy light. Avoid pure yellow alone, it feels flat.',
          fr: 'Chaud + orange doux = lumière cosy. Évite le jaune pur seul, ça paraît plat.'
        }
      },
      {
        title: {
          en: 'The bluish glass reflections',
          fr: 'Les reflets bleutés du verre'
        },
        description: {
          en: "Add a few pale blue lines (BG3 or equivalent) on the curve of each jar to suggest the glass thickness. Mark the base of the jar more clearly. Finish with subtle white gel pen highlights on the edges and around the bulb.",
          fr: "Ajoute quelques lignes bleues pâles (BG3 ou équivalent) sur la courbe de chaque bocal pour suggérer l'épaisseur du verre. Marque plus nettement le fond du bocal. Termine avec des petits reflets blancs subtils au stylo gel sur les bords et autour de l'ampoule."
        },
        tip: {
          en: 'Bluish reflections are what make the eye read "glass" rather than just "round shape".',
          fr: "Les reflets bleutés, c'est ce qui fait que l'œil lit \"verre\" plutôt que \"forme ronde\"."
        }
      }
    ],
    proTips: [
      {
        en: 'Glass jars work like ghosts: the scene continues inside them, just lighter and more diffuse.',
        fr: "Les bocaux en verre fonctionnent comme des fantômes : le décor continue à l'intérieur, juste plus pâle et plus diffus."
      },
      {
        en: 'Warm bulb light + cool bluish glass = the cosy contrast that makes lanterns glow.',
        fr: 'Lumière chaude + verre bleuté = le contraste cosy qui fait briller les lanternes.'
      }
    ],
    palette: {
      ohuhu:       ['Y21', 'YR03', 'E21', 'BG3', 'WG1'],
      copic:       ['Y21', 'YR23', 'E21', 'B23', 'C1'],
      prismacolor: ['PC 916', 'PC 1003', 'PC 997', 'PC 1023', 'PC 1072']
    }
  })
};

// Difficulty labels
export const difficultyLabels = {
  beginner: { en: 'Beginner', fr: 'Débutant', color: '#B5C99A' },
  intermediate: { en: 'Intermediate', fr: 'Intermédiaire', color: '#E8A87C' },
  advanced: { en: 'Advanced', fr: 'Avancé', color: '#D4A5A5' }
};

// ========================================
// VIDEO RESOURCES (external YouTube links)
// ========================================
// These are curated external resources to inspire learners.
// Videos open in a new tab — ColoBongo does not host or own these.

const mkVideos = (items) => items.map((item, idx) => ({
  url: item.url,
  label: item.label || {
    en: idx === 0 ? 'Watch a technique' : idx === 1 ? 'Another method' : `Video tip ${idx + 1}`,
    fr: idx === 0 ? 'Voir une technique' : idx === 1 ? 'Voir une autre méthode' : `Astuce vidéo ${idx + 1}`
  },
  credit: item.credit || null,         // ex: '@jen.stresslesscolo' - string ou null
  difficulty: item.difficulty || null, // 'beginner' | 'intermediate' | 'advanced' - ou null
}));

export const textureVideos = {
  water: mkVideos([
    {
      url: 'https://www.tiktok.com/@jen.stresslesscolo/video/7638802430364323090',
      credit: '@jen.stresslesscolo',
      difficulty: 'beginner',
      label: { fr: "Colorier de l'eau", en: 'Coloring water' }
    },
    { url: 'https://www.youtube.com/shorts/EZ0t2adGe-c' },
    { url: 'https://www.youtube.com/shorts/uOU1E5ZEHng' }
  ]),
  knit: mkVideos([
    { url: 'https://www.youtube.com/shorts/Lf4I0yC9-ws' }
  ]),
  fur: mkVideos([
    { url: 'https://www.youtube.com/shorts/CFpxAwoPaBo' },
    {
      url: 'https://www.tiktok.com/@cath.drolet/video/7642527879712066837',
      credit: '@cath.drolet',
      difficulty: 'intermediate'
    }
  ]),
  leopard: mkVideos([
    {
      url: 'https://www.tiktok.com/@alexj9867/video/7643217543288589586',
      credit: '@alexj9867',
      difficulty: 'beginner',
      label: { fr: 'Version rose', en: 'Pink version' }
    },
    {
      url: 'https://www.tiktok.com/@lililabest/video/7641028754931731732',
      credit: '@lililabest',
      difficulty: 'beginner',
      label: { fr: 'Version classique', en: 'Classic version' }
    }
  ]),
  grass: mkVideos([
    { url: 'https://www.youtube.com/shorts/8LY_rWKDyhA' },
    { url: 'https://www.youtube.com/shorts/o9wVCEtlHy4' }
  ]),
  wood: mkVideos([
    { url: 'https://www.youtube.com/shorts/9soR7ci5ouY' },
    { url: 'https://www.youtube.com/shorts/Fn8Erx7mWpg' }
  ]),
  leaves: mkVideos([
    { url: 'https://www.youtube.com/shorts/9umDD8otBic' }
  ]),
  cactus: mkVideos([
    {
      url: 'https://www.tiktok.com/@cath.drolet/video/7643023296782404884',
      credit: '@cath.drolet',
      difficulty: 'beginner'
    }
  ]),
  flowers: mkVideos([
    {
      url: 'https://www.tiktok.com/@kscozystudio/video/7645573814234942751',
      credit: '@kscozystudio',
      difficulty: 'beginner'
    }
  ]),
  brick: mkVideos([
    { url: 'https://www.youtube.com/shorts/W0zXOD5rwo8' },
    { url: 'https://www.youtube.com/shorts/NtoJ_OjU4lg' }
  ]),
  rock: mkVideos([
    {
      url: 'https://www.tiktok.com/@colobycamille/video/7641179646385491221',
      credit: '@colobycamille',
      difficulty: 'intermediate',
      label: { fr: 'Voir une technique', en: 'Watch a technique' }
    }
  ]),
  fabric: mkVideos([
    { url: 'https://www.youtube.com/shorts/6pZlZRhGJTk' }
  ]),
  tiles: mkVideos([
    { url: 'https://www.youtube.com/shorts/lf2PwARopTI' }
  ]),
  sky: mkVideos([
    { url: 'https://www.youtube.com/shorts/jWOxf7OplJo' },
    { url: 'https://www.youtube.com/shorts/iZNKKmJygNU' },
    { url: 'https://www.youtube.com/shorts/7EVsHC1mJyo' },
    { url: 'https://www.youtube.com/shorts/X3-cnzftoqA' },
    { url: 'https://www.youtube.com/watch?v=tKciWhANhy4' }
  ]),
  // rain/pluie
  rain: mkVideos([
    { url: 'https://www.youtube.com/shorts/DEwNHsr4iwk' }
  ]),
  // cloud/nuage — future texture slug
  cloud: mkVideos([
    { url: 'https://www.youtube.com/shorts/-9kTvmkOrOU' }
  ]),
  bubbles: mkVideos([
    {
      url: 'https://www.tiktok.com/@vivi_levesque/video/7644735728928296212',
      credit: '@vivi_levesque',
      difficulty: 'beginner',
      label: { fr: "Bulles d'eau", en: 'Water bubbles' }
    },
    {
      url: 'https://www.youtube.com/shorts/dIWm0wa_f-s',
      label: { fr: 'Bulles de savon', en: 'Soap bubbles' }
    },
    {
      url: 'https://www.youtube.com/shorts/VvaHXjsJ8Uk',
      label: { fr: 'Bulles de savon — autre méthode', en: 'Soap bubbles — another method' }
    },
    {
      url: 'https://www.youtube.com/shorts/bIpFELbaYqU',
      label: { fr: 'Bulles de savon — astuce', en: 'Soap bubbles — tip' }
    }
  ]),
  'glass-jars': mkVideos([
    {
      url: 'https://www.tiktok.com/@_karinelle_/video/7643648548352953621',
      credit: '@_karinelle_',
      difficulty: 'advanced',
      label: { fr: 'Bocaux de lumière', en: 'Glass jar lanterns' }
    }
  ])
};

// ============================================================
// CONVENIENCE CONSTANTS & HELPERS (used by TextureCard, TexturesPage, TextureDetail)
// ============================================================

/** Texture availability status constants. */
export const TEXTURE_STATUS = {
  available: 'available',
  comingSoon: 'coming_soon',
  premium: 'premium',
};

/**
 * Difficulty map keyed by level name.
 * Mirrors difficultyLabels but keyed for direct lookup.
 */
export const DIFFICULTY = {
  beginner:     { en: 'Beginner',     fr: 'Débutant',       color: '#B5C99A' },
  intermediate: { en: 'Intermediate', fr: 'Intermédiaire',  color: '#E8A87C' },
  advanced:     { en: 'Advanced',     fr: 'Avancé',         color: '#D4A5A5' },
};

/** Ordered list of difficulty level keys. */
export const difficultyLevels = ['beginner', 'intermediate', 'advanced'];

/**
 * Flat texture array alias — same data as textureCategories.
 * TexturesPage filters/searches over this list.
 */
export const texturesData = textureCategories;

/** Returns all textures that are currently available (not coming-soon or premium). */
export function getAvailableTextures() {
  return textureCategories.filter(
    (t) => !t.status || t.status === TEXTURE_STATUS.available
  );
}

/** Returns all textures that are coming soon. */
export function getComingSoonTextures() {
  return textureCategories.filter((t) => t.status === TEXTURE_STATUS.comingSoon);
}

/** Returns the texture category matching the given slug, or undefined. */
export function getTextureBySlug(slug) {
  return textureCategories.find((t) => t.slug === slug);
}
